import ImageUrlMixin from '~/mixins/ImageUrlMixin.vue'
import PageHomepage from '~/themes/oknanebodvere/components/shop/PageHomepage'

const FALLBACK_CATEGORY_CARDS = [
  {
    imageVariant: 'window',
    title: 'Okna',
    subtitle: 'jednokřídlá, dvoukřídlá, trojkřídlá',
    stockText: 'Skladem',
    customText: 'Chci na míru',
    customSlug: 'plastova-okna-na-miru-zakazkova-vyroba',
    icon: require('@icon/hp-windows.svg?raw'),
    image: {
      fallback: '/assets/images/homepage-category-window.png',
      src:
        'oknanebodvere/store/production/data/persistent/products_categories/0/5/65/smart-okno-na-miru-kategorie-hotovo-barva__iqPG.png',
    },
  },
  {
    imageVariant: 'entrance',
    title: 'Vchodové dveře',
    subtitle: 'jednokřídlé, dvoukřídlé',
    stockText: 'Skladem',
    customText: 'Chci na míru',
    customSlug: 'plastove-vchodove-dvere-na-miru-zakazkova-vyroba',
    icon: require('@icon/hp-doors.svg?raw'),
    image: {
      fallback: '/assets/images/hero-mobile.webp',
      src: '/assets/images/hero-mobile.webp',
    },
  },
  {
    imageVariant: 'balcony',
    title: 'Balkónové dveře',
    subtitle: 'jednokřídlé, dvoukřídlé',
    stockText: 'Skladem',
    customText: 'Chci na míru',
    customSlug: 'plastove-balkonove-dvere-na-miru-zakazkova-vyroba-1',
    icon: require('@icon/hp-balcony-door.svg?raw'),
    image: {
      fallback: '/assets/images/window-cart.webp',
      src: '/assets/images/window-cart.webp',
    },
  },
]

const UNAVAILABLE_CATEGORY_IMAGE_PATHS = [
  'oknanebodvere/store/production/data/persistent/products_categories/0/5/68/smart-vchodove-dvere-na-miru-kategorie-hotovo__JPOZ.png',
  'oknanebodvere/store/production/data/persistent/products_categories/0/5/71/smart-balkonove-dvere-na-miru-kategorie-hotovo__fc1g.png',
]

export default {
  extends: PageHomepage,
  mixins: [ImageUrlMixin],
  computed: {
    customCategories() {
      return this.normalizeHomepageCategory('categoriesCustom', 'order', 'custom')
    },
    homepageCategoryCards() {
      const cardConfig = this.getHomepageCategoryCardConfig()
      const customCategories = this.customCategories.items.filter(this.isHomepageCategoryVisible)
      const stockCategories = this.stockCategories.items.filter(this.isHomepageCategoryVisible)
      const cardCount = Math.max(cardConfig.length, customCategories.length, stockCategories.length)

      return Array.from({ length: cardCount }, (_, index) => {
        const config = cardConfig[index] || {}
        const customCategory = customCategories[index] || {}
        const stockCategory = stockCategories[index] || {}

        return {
          custom: {
            text: config.customText || customCategory.action_title,
            to: this.getHomepageCategoryCustomTo(config, customCategory),
          },
          icon: config.icon || null,
          image: config.icon ? null : this.getHomepageCategoryCardImage(customCategory, stockCategory, config),
          imageVariant: config.imageVariant,
          stock: {
            text: config.stockText || stockCategory.action_title,
            to: stockCategory.to || '/',
          },
          subtitle: config.subtitle || '',
          title: config.title || customCategory.title || stockCategory.title,
        }
      })
    },
    stockCategories() {
      return this.normalizeHomepageCategory('categoriesStock', 'stock', 'stock')
    },
  },
  methods: {
    getHomepageCategoryCardConfig() {
      return FALLBACK_CATEGORY_CARDS
    },
    getHomepageCategoryCustomTo(config, customCategory) {
      if (config.customSlug) {
        return this.localePath({ name: 'all', params: [config.customSlug] })
      }

      return customCategory.to || '/'
    },
    isHomepageCategoryVisible(category) {
      return !this.isInteriorDoorCategory(category)
    },
    isInteriorDoorCategory(category = {}) {
      const categoryText = [category.action_title, category.link, category.title].filter(Boolean).join(' ')

      return this.normalizeCategoryText(categoryText).includes('interierov')
    },
    normalizeCategoryText(text) {
      return text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
    },
    getHomepageCategoryCardImage(customCategory, stockCategory, config) {
      const configImage = typeof config.image === 'object' ? config.image : { src: config.image || '' }
      const storeImage = this.getRealCategoryImage(customCategory) || this.getRealCategoryImage(stockCategory)
      const availableStoreImage = UNAVAILABLE_CATEGORY_IMAGE_PATHS.includes(storeImage) ? '' : storeImage

      return {
        fallback: configImage.fallback || configImage.src,
        src: availableStoreImage || configImage.src,
      }
    },
    homepageCategoryImageSrc(image) {
      return this.resolveHomepageCategoryImageUrl(image?.src)
    },
    resolveHomepageCategoryImageUrl(src) {
      if (!src) return ''
      if (this.isDirectImage(src)) return src

      return this.imageUrl({
        height: 150,
        src,
        webP: true,
        width: 190,
      })
    },
    setHomepageCategoryImageFallback(event, image) {
      const fallback = image?.fallback
      const target = event.target

      if (!fallback || target.dataset.fallbackApplied === 'true') return

      target.dataset.fallbackApplied = 'true'
      target.src = this.resolveHomepageCategoryImageUrl(fallback)
    },
    isDirectImage(src = '') {
      return /^https?:\/\//.test(src) || src.startsWith('/')
    },
    getTranslatedCategoryConfig(translationKey) {
      const config = this.$t(`Homepage.categories.${translationKey}`)
      return config && typeof config === 'object' ? config : { items: [] }
    },
    getRealCategoryImage(category) {
      return category && !category.isFallback ? category.image : ''
    },
    normalizeHomepageCategory(storeKey, translationKey, type) {
      const source = this.$store.state.category[storeKey]
      const sourceItems = Array.isArray(source?.configurable_categories) ? source.configurable_categories : []

      if (sourceItems.length > 0) {
        return {
          items: sourceItems.map(item => this.normalizeStoreCategoryItem(item, type)),
          title: source.title,
        }
      }

      const fallback = this.getTranslatedCategoryConfig(translationKey)
      const fallbackItems = Array.isArray(fallback.items) ? fallback.items : []

      return {
        items: fallbackItems.map(item => this.normalizeTranslatedCategoryItem(item, type)),
        title: fallback.title,
      }
    },
    normalizeStoreCategoryItem(item, fallbackType) {
      const category = item.configurable_categories?.[0]?.entity.data
      const slug = category?.slug

      return {
        action_title: item.action_title,
        image: this.getStoreCategoryImage(category),
        isFallback: false,
        link: slug || '',
        title: item.title,
        to: slug ? this.localePath({ name: 'all', params: [slug] }) : '/',
        type: item.category_item_type?.[0] || fallbackType,
      }
    },
    getStoreCategoryImage(category) {
      return (
        category?.mainImage || category?.image || category?.images?.[0]?.src || category?.main_image?.[0]?.path || ''
      )
    },
    normalizeTranslatedCategoryItem(item, type) {
      return {
        action_title: item.buttonText,
        image: item.image || '',
        isFallback: true,
        link: item.buttonLink || '/',
        title: item.title,
        to: item.buttonLink || '/',
        type,
      }
    },
  },
}
